/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_1_AInputs */

const en_mk_tut_tr_1_a = /** @type {(inputs: Mk_Tut_Tr_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check two things: whether this month’s task quota still has room (Plan & billing), and whether that agent has permission for the issue. If quota ran out the task is held and runs by itself once quota returns.`)
};

const id_mk_tut_tr_1_a = /** @type {(inputs: Mk_Tut_Tr_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa dua hal: apakah kuota tugas bulan ini masih ada (menu Paket & tagihan), dan apakah agen itu punya izin untuk issue tersebut. Kalau kuota habis, tugas ditahan dan otomatis dijalankan setelah kuota tersedia.`)
};

/**
* | output |
* | --- |
* | "Check two things: whether this month’s task quota still has room (Plan & billing), and whether that agent has permission for the issue. If quota ran out the ..." |
*
* @param {Mk_Tut_Tr_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_1_a = /** @type {((inputs?: Mk_Tut_Tr_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_1_a(inputs)
	return en_mk_tut_tr_1_a(inputs)
});